module.exports = __webpack_public_path__ + "media/categories-photos/20-ded6ccd3.webp";